export default "__VITE_ASSET__OaeI0VcE__"